import { NotifyErrorWrapper, NotifySuccess } from '@/helpers/core/notifications'
import { createPartDamage, deletePartDamage } from '@/services/rc/miners.service'
import type { IPartDamageCreationForm, IPartDamageDeletionForm } from '@/types/rc/miners/forms'
import { useMutation, useQueryClient } from '@tanstack/vue-query'
import type { Ref } from 'vue'

export const useMinerPartDamages = (minerId: Ref<number>) => {
  const queryClient = useQueryClient()

  const createPartDamageMutation = useMutation({
    mutationFn: (form: IPartDamageCreationForm) => createPartDamage(minerId.value, form),
    onError: NotifyErrorWrapper('Error creating part damage'),
    onSuccess: () => {
      NotifySuccess(`Part damage created successfully`)
      queryClient.invalidateQueries({ queryKey: ['miner-details', minerId] })
    },
  })

  const deletePartDamageMutation = useMutation({
    mutationFn: (data: IPartDamageDeletionForm) => deletePartDamage(minerId.value, data),
    onError: NotifyErrorWrapper('Error deleting part damage'),
    onSuccess: () => {
      NotifySuccess(`Part damage deleted successfully`)
      queryClient.invalidateQueries({ queryKey: ['miner-details', minerId] })
    },
  })

  return {
    createPartDamageMutation,
    deletePartDamageMutation,
  }
}
